import { useEffect, useState } from 'react';

export const compactMapMediaQuery = '(max-width: 1024px)';

const getIsMobileViewport = () => {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(compactMapMediaQuery).matches;
};

export function useMobileViewport() {
  const [isMobileViewport, setIsMobileViewport] = useState(getIsMobileViewport);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(compactMapMediaQuery);
    const handleChange = (event: MediaQueryListEvent) => setIsMobileViewport(event.matches);

    setIsMobileViewport(mediaQueryList.matches);
    mediaQueryList.addEventListener('change', handleChange);
    return () => mediaQueryList.removeEventListener('change', handleChange);
  }, []);

  return isMobileViewport;
}
